import type { Session } from "./session";

/**
 * Quién puede entrar en cada zona. La API vuelve a comprobarlo todo: esto solo
 * decide qué se enseña.
 *
 * - `member`: cualquier miembro de la organización actual (rol `admin` o `user`).
 * - `admin`: rol `admin` en la organización actual.
 * - `platform`: administrador de plataforma (Punto). No depende de la
 *   organización y no da acceso a los datos de ninguna.
 */
export type Access = "member" | "admin" | "platform";

export const canAccess = (session: Session, access: Access): boolean => {
  switch (access) {
    case "member":
      return session.currentOrganization !== null;
    case "admin":
      return session.isAdmin;
    case "platform":
      return session.isPlatformAdmin;
  }
};
